import { Grid } from "@material-ui/core";
import { Autorenew, Edit, Schedule } from "@material-ui/icons";
import React from "react";
import { ExamSessionCandidateExamState } from "../../../model/examSessionCandidate/ExamSessionCandidateExamViewModel";
import CustomButton from "../../common/buttons/CustomButton";
import TranslatedMessage from "../../translations/TranslatedMessage";

interface ExamSessionCandidateExamActionsProps {
  examState: ExamSessionCandidateExamState;
  disabled?: boolean;
  hideRebookButton?: boolean;
  hideEditStateButton?: boolean;
  hideResetStateButton?: boolean;
  rebook: () => void;
  toggleExamManualState: () => void;
  isTermPaper: boolean;
}

const ExamSessionCandidateExamActions: React.FunctionComponent<ExamSessionCandidateExamActionsProps> = ({
  examState,
  disabled,
  hideRebookButton,
  hideEditStateButton,
  hideResetStateButton,
  rebook,
  toggleExamManualState,
  isTermPaper
}) => {
  const isBookedExam = examState !== ExamSessionCandidateExamState.Cancelled;

  if (isBookedExam) {
    return (
      <Grid container={true}>
        {hideEditStateButton !== true && (
          <CustomButton
            tooltip={<TranslatedMessage id="examSessionCandidate.setManualState" />}
            onClick={toggleExamManualState}
            disabled={disabled}
          >
            <Edit />
          </CustomButton>
        )}
        {hideResetStateButton !== true && (
          <CustomButton
            tooltip={<TranslatedMessage id="examSessionCandidate.resetManualState" />}
            onClick={toggleExamManualState}
            disabled={disabled}
          >
            <Autorenew />
          </CustomButton>
        )}
        {hideRebookButton !== true && !isTermPaper && (
          <CustomButton
            tooltip={<TranslatedMessage id="examSessionCandidate.locationAndDateEdit" />}
            onClick={rebook}
            disabled={disabled}
          >
            <Schedule />
          </CustomButton>
        )}
      </Grid>
    );
  }

  if (hideRebookButton) {
    return null;
  }

  return (
    <Grid container={true}>
      <CustomButton
        tooltip={<TranslatedMessage id="examSessionCandidate.rebook" />}
        onClick={rebook}
        disabled={disabled}
      >
        <TranslatedMessage id="examSessionCandidate.rebook" />
      </CustomButton>
    </Grid>
  );
};

export default ExamSessionCandidateExamActions;
